import { pick } from 'ramda'
import YamlTemplateParser from 'utils/YamlTemplateParser'
import clusterUpgradeJobSchema from './cluster-upgrade-job.json'

const createUpgradeJobName = (clusterName, targetVersion, upgradeJobs) => {
  const attemptNum = upgradeJobs?.reduce((accum, job) => {
    if (job?.targetVersion === targetVersion) {
      accum += 1
    }
    return accum
  }, 0)
  return `${clusterName}-${targetVersion}-${attemptNum}`
}

const formatNodeGroups = (nodeGroups = [], upgradeImageName) => {
  return nodeGroups?.map((nodeGroup) => {
    return {
      ...pick(['apiVersion', 'kind', 'name'], nodeGroup),
      upgradeImageName,
    }
  })
}

const formatAddons = (addons = [], eksAddons = []) => {
  const formattedAddons = addons?.map((addon) => {
    return {
      name: addon.type,
      kind: 'ClusterAddon',
      apiVersion: 'sunpike.platform9.com/v1alpha2',
    }
  })
  const formattedEksAddons = eksAddons?.map((addon) => {
    return {
      name: addon.name,
      kind: 'EKSClusterAddon',
      apiVersion: 'controlplane.cluster.x-k8s.io/v1beta1',
    }
  })
  return [...formattedAddons, ...formattedEksAddons]
}

export const createClusterUpgradeJobBody = (params: {
  clusterName: string
  nodeGroups?: any[]
  upgradeJobs?: any[]
  targetVersion: string
  upgradeImageName: string
  isControlPlane: boolean
  isByohCluster: boolean
}) => {
  const {
    clusterName,
    nodeGroups,
    upgradeJobs,
    targetVersion,
    upgradeImageName,
    isControlPlane,
    isByohCluster,
  } = params
  const jobName = createUpgradeJobName(clusterName, targetVersion, upgradeJobs)
  const templateParser = new YamlTemplateParser(clusterUpgradeJobSchema)
  templateParser.setValues({
    ...params,
    name: jobName,
    ...(isControlPlane && !isByohCluster ? { controlPlane: { upgradeImageName } } : {}),
    nodeGroups: formatNodeGroups(nodeGroups, upgradeImageName),
    // addons: formatAddons(addons, eksAddons),
  })
  return templateParser.getJson()
}
